export default __webpack_public_path__ + "5d92cb7c0d494e2ecaaf8e3dcfb1ec7f.jpg";